import { isRotatable, type Frame, type FiguresPrompt } from '../generators/figures.ts'
import { FigureShapeGlyph } from './shapes.tsx'

/** One 4×4 matrix of still figures (nothing animates), drawn as inline SVG —
 * no image files to ship (PLAN-Z M7). */
export function FigureMatrix({ frame, label }: { frame: Frame; label?: string }) {
  return (
    <svg viewBox="0 0 80 80" role="img" aria-label={label ?? '4 by 4 matrix'} className="figure-matrix-svg">
      {Array.from({ length: 16 }, (_, i) => (
        <rect
          key={i}
          x={(i % 4) * 20}
          y={Math.floor(i / 4) * 20}
          width="20"
          height="20"
          className="figure-cell"
        />
      ))}
      {frame.map((f, i) => (
        <g key={i} transform={`translate(${f.col * 20},${f.row * 20})`}>
          <g
            transform={
              isRotatable(f.shape) && f.orientation !== 0
                ? `rotate(${f.orientation * 90},10,10)`
                : undefined
            }
          >
            <FigureShapeGlyph shape={f.shape} colour={f.colour} />
          </g>
        </g>
      ))}
    </svg>
  )
}

/** The four stem frames of a figure-sequence item (frames 1–4). Desktop shows
 * one row; phones stack 2×2 via CSS (PLAN.md §7). */
export function FiguresStem({ prompt }: { prompt: FiguresPrompt }) {
  return (
    <div className="figures-stem">
      {prompt.stem.map((frame, i) => (
        <FigureMatrix key={i} frame={frame} label={`Frame ${i + 1}`} />
      ))}
    </div>
  )
}
